import { Box } from '@mui/material';

import Filter from '../../../../../../common/reports/actions/utils/filter';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';

import locales from '../locales';
import { PayoutReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: PayoutReportDetailsMetadataResponse;
}

const FiltersSummary = ({ filters }: Props) => (
  <Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.startingDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.from })}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.endDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.statuses.label}
          value={filters.statuses.length > 0 ? filters.statuses.join(', ') : '< All >'}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.operationIds.label}
          value={filters.operationIds.length > 0 ? filters.operationIds.join(', ') : '< All >'}
        />
      </Box>
    </Box>
  </Box>
);

export default FiltersSummary;
